// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c5ceafd0","147":"86e53656","195":"aec0546c","264":"10054f32","382":"f5a0ef9d","466":"9e3f8e90","492":"54c25168","566":"187a7277","726":"254bebfd","828":"7e391bb3","838":"79c26535","859":"e085f9a9","872":"91093b68","883":"a4dffd4a","971":"ae91b814"}[chunkId] + ".chunk.js";
};